import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { Link } from "react-router-dom";
import GetUserToken from "../component/getToken";
import Footer from "../component/Footer";
import { baseUrl } from "../assets/baseUrl";

export default class LecturesAndFiles extends Component {
  state = {
    monthes: [],
    subid: "",
  };

  componentDidMount() {
    const token = GetUserToken();
    const subjectId = this.props.match.params.id;

    axios
      .get(`${baseUrl}api/Lectures/MonthsForSubject/${subjectId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        this.setState({
          monthes: [...res.data].sort((a, b) => a - b),
          subid: subjectId,
        });
      })
      .catch(() => {
        toast.error("لا يوجد محاضرات لهذه المادة");
      });
  }

  render() {
    const { monthes, subid } = this.state;

    return (
      <div>
        <div
          className="breadcrumb"
          style={{
            backgroundImage: `url('${process.env.PUBLIC_URL}/images/levelsLogo.jpg')`,
          }}
          data-aos="fade-up"
          data-aos-duration="2000"
        >
          <h5>المحاضرات</h5>
        </div>

        <div className="month-page">
          <Container>
            <h5 className="list-header">
              يجب عليك اختيار الشهر لرؤية المحاضرات
            </h5>
            <br />
            <br />
            <Grid container spacing={3}>
              {monthes.map((month) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={month}>
                  <Link to={`/lectures/${subid}/${month}`} className="month-card">
                    {month}
                  </Link>
                </Grid>
              ))}
            </Grid>
            <br />
            <br />
          </Container>
        </div>
        <Footer />
      </div>
    );
  }
}
